import 'bootstrap/dist/css/bootstrap.min.css';
import React, { lazy, useContext, useEffect, useState } from 'react';
import { Accordion, Badge, Button, CloseButton, Col, Container, FloatingLabel, Form, Image, InputGroup, NavDropdown, Row, Tab, Tabs, Toast, ToggleButton } from 'react-bootstrap';
import SBAlert from 'react-bootstrap/Alert';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { LanguageCtx, LoginInfo } from '../App';
import { followDelete, followPost } from '../service/FollowService';
import ApiFetch from './ApiFetch';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import parse, { domToReact } from 'html-react-parser'
import { isLoggin, login, updateRenzoku, updateTile } from '../service/LoginService';
import { t } from 'i18next';
import i18n from '../i18n/config';
import UserInfoPopup from './common/UserInfoPopup';
import FollowButton from './FollowButton';
import QuestionAnswer from './QuestionAnswer';
import EditPopup from './EditPopup';
import Thumb from './common/Thumb';
import Tile from './common/Tile';
import Masonry from 'react-masonry-css';
import RegistOrLoginPopup from './RegistOrLogin';
import RegistOrLogin from './RegistOrLogin';
import ReactGA from "react-ga4";
import MuteButton from './MuteButton';
import UserAvatarWithLikes from './UserAvatarWithLikes';
import Report from './Report';
import UserManageInfo from './UserManageInfo';
import Comment from './Comment';
import PointSend from './PointSend';
import Reply from './Reply';
import "../scss/favorite.scss"
import FavoriteIconV2 from './FavoriteIconV2';
import SeriesEditPopup from './SeriesEditPopup';
import UserMark from './UserMark';
import DynamicDialog from './DynamicDialog';
import Moveable from "moveable";
import Clap from './Clap';
import AdmaxSwitch from './common/AdMax';
import { arrayShuffle, imgPath, moveable, resetPosition, resettable, zoomable } from '../service/CommonUtil';
import AdIMobile from './common/AdIMobile';
import AdSence from './common/AdSence';
import DLsite from './DLsite';
import MuiButton from "@mui/material/Button";
import { Alert, Chip, Grid, LinearProgress, useTheme } from '@mui/material';
import Plan from './Plan';
import LockIcon from '@mui/icons-material/Lock';
import BuyConfirmDialog from './common/BuyConfirmDialog';
import CharacterProfileCard from './common/CharacterProfileCard';
import CommonDialog from './common/CommonDialog';
import Gallery from './common/Gallery';
import ImagePreview from './common/ImagePreview';
import OfficialPlanCards from './common/OfficialPlanCards';

const ImageViewPopup = (props) => {
    async function getImageList(style,genre,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/new/"+style+"/"+genre+"//"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserImageList(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/user/"+userId+"/favorite_desc/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImageInfo(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/info/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getLimitedDataList(groupId,index){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/limitedData/"+groupId+"/"+index).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImageReply(groupId,replyCommentId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/reply/"+groupId+"/"+replyCommentId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImageReply(groupId,replyCommentId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/reply/"+groupId+"/"+replyCommentId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImage(groupId){
        let deletePassword = document.getElementById("delete-password").value
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/post/"+groupId,{deletePassword:deletePassword}).then((r)=>r.json().then((d)=>{
            return d
        }))
    }
    async function getStamp(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/stamp/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getFavoriteUserList(id,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/image/userList/"+id+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateAgeLimitByAdmin(groupId,ageLimit){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/ageLimit/"+groupId,{ageLimit:ageLimit})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateStyleOfPaintingByAdmin(groupId,style){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/style/"+groupId,{style:style})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function sendMosaicNoticeByAdmin(groupId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/mosaic/"+groupId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function sendChildPornNoticeByAdmin(groupId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/childPorn/"+groupId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateStatusByAdmin(userId,status,reason){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/status/"+userId,{status:status,reason:reason})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function search(keyword,style,nenrei,follow,auth,aiOrModel,user,tag,order,page){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/search/",
            {keyword:keyword,style:style,ageLimit:nenrei,follow:follow,auth:auth,aiOrModel:aiOrModel,user:user,tag:tag,postDateFrom:"",postDateTo:"",order:order,page:page}
        ).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function get3MonthAvg(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/pageview/3MonthAvg").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getSeriesList(userId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/list/"+userId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteSeries(seriesId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series",{seriesId:seriesId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function searchBanByAdmin(userId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userScore/searchBan/"+userId,{})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function aiGenerateSuspendByAdmin(userId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/aiGenerateSuspend/"+userId,{})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getLatestCommentList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/latestCommentList")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const location = useLocation()
    // 投稿処理
    function upload(postType,text,groupId,stampId,commentId){
        let fapi = new ApiFetch()
        let fd = new FormData()
        fd.append("text",text)
        fd.append("stamp_id",stampId === undefined ? "" : stampId)
        commentId = commentId || ""
        fapi.fileUpload(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/reply/"+groupId+"/"+commentId,fd).then((r)=>{
            r.json().then(json=>{
                if(json.result){
                    let text = document.getElementById("text")
                    text.value = ""
                    getImageReply(groupId,"",1).then(r=>{
                        if(r.result){
                            setImageReplyInfo(r.detail)
                        }
                    })
                } else {
                    dialog("エラー",json.errors.join("\r\n"))
                }
            })
        })
    }
    // クリップボードにコピー
    function copyTextToClipboard(text) {
        return navigator.clipboard.writeText(text)
    }
    let param = useParams()

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    // ユーザ情報ポップアップ
    const [displayId,setDisplayId] = useState()
    const [selfIntroduction,setSelfIntroduction] = useState()
    const [followPopup,setFollowPopup] = useState()
    const [follower,setFollower] = useState()

    // ナビゲート
    const navigate = useNavigate()

    const tagReplace = (node) => {
        if (node.name === 'span' && node.attribs.tag !== undefined) {
          return (
            <span {...node.attribs} onClick={() => navigate("/tag/"+node.attribs.tag+"/1")} style={{color:"#00AAFF",cursor:"pointer"}}>
              #{ domToReact(node.children) }
            </span>
          )
        }
        if (node.name === 'span' && node.attribs.href !== undefined) {
            return (
              <span {...node.attribs} onClick={() => setGroupId(node.attribs.href)} style={{color:"#00AAFF",cursor:"pointer"}}>
                { domToReact(node.children) }
              </span>
            )
        }
        if (node.name === 'a') {
            return (
              <a href={"/jump/" + encodeURIComponent(node.attribs.href)}>{node.attribs.href}</a>
            )
        }
    }

    // 削除対象
    const [item, selectItem] = useState('')
    const [deleted, setDeleted] = useState('')

    // 画像遅延ロード
    const options = {
        root: null,
        rootMargin: "100px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target
                //imgEl.src = imgEl.dataset.src
                observer.unobserve(entry.target)
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.className === "replyLazy" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imageReplyPage * 10 - 1) ){
                    setImageReplyPage(imageReplyPage+1)
                }
                let lazyCount = document.querySelectorAll(".lazy-popup").length
                let lazyHiddenCount = document.querySelectorAll(".lazy-hidden").length
                let imageCount = lazyCount + lazyHiddenCount
                if((imgEl.className === "p-1 lazy-popup" || imgEl.className === "lazy-hidden")
                    && (imageCount - 1) === (imagePage * 30 - 1) && lazyCount < 31 && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 30 - 1)){
                    setImagePage(imagePage + 1)
                }
                if(imgEl.className === "lazy-popup" && imgEl.dataset.type === "favorite" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (favoriteUserListPage * 30 - 1) ){
                    setFavoriteUserListPage(favoriteUserListPage+1)
                }
                if(imgEl.className === "p-0 lazy-popup container" && imgEl.dataset.type === "search"){
                    setSearchImage(Math.random())
                }
              }
        })
    }, options)

    const [view,setView] = useState(false)
    const [zoomMode,setZoomMode] = useState(false)
    const [groupId,setGroupId] = useState(props.groupId)
    const [imageInfo,setImageInfo] = useState({info:{id:"",title:"",description:""},detail:[{prompt:"",ext:""}]})
    const [userImageList,setUserImageList] = useState([])
    const [imageInfoStatus,setImageInfoStatus] = useState(false)
    const [limitDiv,setLimitDiv] = useState("public")
    const [planAccess,setPlanAccess] = useState(false)
    const [limitedDataList,setLimitedDataList] = useState([])
    const [imageDisplayFlag,setImageDisplayFlag] = useState(0)
    const [detailNo,setDetailNo] = useState(0)
    const [imagePage,setImagePage] = useState(1)
    const [imageList,setImageList] = useState([])
    const [stampOfficial,setStampOfficial] = useState(true)
    const [stampList,setStampList] = useState([])
    const [stampPage,setStampPage] = useState(0)
    const [stampMessage,setStampMessage] = useState("")
    const [width,setWidth] = useState(window.innerWidth*0.8)
    const [height,setHeight] = useState(window.innerHeight*0.8)
    const [follow,setFollow] = useState(false)
    const [okButtonShow,setOkButtonShow] = useState(false)
    const [pv,setPV] = useState(1)
    const [url,setURL] = useState("")
    const [urlAffi,setURLAffi] = useState("")
    const [questionId,setQuestionId] = useState("")
    const [tag,setTag] = useState("")
    const [searchImage,setSearchImage] = useState(0)
    const [tabKey,setTabKey] = useState("")
    const [showKanren,setShowKanren] = useState(false)

    // 管理者用
    const [adminSelectItem,setAdminSelectItem] = useState("allAges")

    // お気に入りユーザ一覧
    const [favoriteUserList,setFavoriteUserList] = useState([])
    const [favoriteUserListPage,setFavoriteUserListPage] = useState(1)
    const [showFavoriteUserList,setShowFavoriteUserList] = useState(false)

    // 返信情報
    const [imageReplyPage,setImageReplyPage] = useState(0)
    const [imageReplyInfo,setImageReplyInfo] = useState([])

    // コメント一覧
    const [latestCommentList,setLatestCommentList] = useState([])

    // 初期処理
    useEffect(() =>{
        if(groupId.indexOf("/") !== -1){
            setGroupId(groupId.replace("/",""))
            return
        }
        // スクロールを最上位に戻す
        document.getElementById("popup-view").scrollTo({top:0,left:0,behavior:"instant"})
        setOkButtonShow(false)
        getImageInfo(groupId).then(json => {
            if(json.result){
                let info = json.info

                setImageDisplayFlag(info.confirm_flag)                
                if(!info.is_logged_in){
                    // ログイン確認できないため、ログイン情報を削除
                    setLoginInfo([])
                }
                // 質問ID
                setQuestionId(json.info.question_id)
                // 情報を保持
                setImageInfo(json)
                // フォロー状況を設定
                setFollow(json.info.follow)
                // PVを設定
                setPV(json.info.pv)
                // データ受信状況を設定
                setImageInfoStatus(true)
                // タイトル設定
                document.querySelector("title").textContent = json.info.title + "のイラスト - アワートAI"

                setLimitDiv(json.info.limit_div)
                setPlanAccess(json.info.plan_access === 1)
                if(json.info.limit_div != "public" && json.info.plan_access === 1 || json.info.unit_amount !== undefined && json.info.unit_amount > -1 && json.info.is_purchased === 1){
                    // 支援者限定コンテンツを取得
                    let limitedList = []
                    json.detail.map((d,i) => {
                        console.log("a",d.sort_order)
                        return getLimitedDataList(groupId,i).then(r => {
                            if(r.result){
                                d.base64 = r.list
                            } else {
                                d.base64 = []
                            }
                            limitedList[d.sort_order] = r.list
                            setLimitedDataList(limitedList)
                            console.log("b",d.sort_order)
                        })
                    })
                }

                ReactGA.initialize("G-7W9JKQ50Y6");
                ReactGA.send({
                  hitType: "pageview",
                  // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
                  page: "/image/" + groupId,
                })

                // タグ
                let tags = json.info.tags.filter(tag => {
                    // 自動で追加するタグは除外する
                    return tag !== "AIイラスト"
                }).map(tag => "#" + tag).join(" ")
                // URL
                setURL("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                    + encodeURIComponent("「アワートAI」AI活用プラットフォームの投稿を共有しました！\nタイトル：「" + json.info.title + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/image/"+groupId + "\n#ourtAI")
                )
                setURLAffi("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                    + encodeURIComponent("「アワートAI」AI活用プラットフォームの投稿を共有しました！\nタイトル：「" + json.info.title + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/image/"+groupId +"?af=" + (json.info.display_id === "" ? json.info.user_id : json.info.display_id) + "\n#ourtAI")
                )
                if(tabKey === "other" && userImageList.length > 0){
                    // ユーザの投稿一覧を取得
                    getUserImageList(info.user_id,1).then(r => {
                        if(r.result){
                            setUserImageList(r.data)
                        }
                    })
                }
                let s = localStorage
                s.removeItem("loginToUrl")

                let genre = ""
                if(info.age_limit === 1){
                    genre = "general"
                } else if(info.age_limit === 2) {
                    genre = "pg12"
                } else if(info.age_limit === 3) {
                    genre = "r15"
                } else if(info.age_limit === 4) {
                    genre = "r18"
                } else if(info.age_limit === 5) {
                    genre = "r18g"
                }
                // 最新の画像を取得する場合はこれ
                let styles = ["illustration","photorealistic","semirealism"]
                let style = styles[info.style_of_painting-1]
                getImageList(style,genre,imagePage).then(r=>{
                    if(r.result){
                        const newList = r.data.filter((a,b) => b < 2).map(d => {
                            d.isAd = false
                            return d
                        })
                        if(info.age_limit === 4 || info.age_limit === 5){
                            setAdList(arrayShuffle(newList.concat(listR18)))
                        } else {
                            setAdList(arrayShuffle(newList.concat(list)))
                        }
                    }
                })
            } else {
                dialog("エラー",json.errors.join("\r\n"))
                if(json.errors.join("\r\n").indexOf("この投稿はログインすると閲覧できます。") !== -1){
                    dialog("この投稿はログインすると閲覧できます。",<RegistOrLogin dialog={dialog} />)
                    /*let s = localStorage
                    s.removeItem("loginToUrl")
                    s.setItem("loginToUrl","image:"+groupId)*/
                    return
                }
                /*let s = localStorage
                s.removeItem("loginToUrl")*/
            }
        })
        setImageReplyPage(1)
        getImageReply(groupId,"",1).then(r=>{
            if(r.result){
                setImageReplyInfo(r.detail)
            } else {
                setImageReplyInfo([])
            }
        })
        //setSwipe("body")

        setSensitiveShow(false)
        getLatestCommentList().then(r => {
            if(r.result){
                setLatestCommentList(r.data)
            }
        })
        setDetailNo(0)
    },[groupId])

    useEffect(() => {
        if(stampPage > 0)
        getStamp(stampOfficial ? "bb37f7e5-7ea5-465a-8ae3-e6ac4bdd2341" : loginInfo.userId,stampPage).then(r => {
            if(r.result){
                setStampList(r.data)
                if(r.data.length === 0){
                    setStampMessage(<span>まだスタンプがありません。オリジナルのスタンプを登録してみませんか？：<Link to={"/stampManage"}>スタンプ管理</Link></span>)
                } else {
                    setStampMessage("")
                }
            }
        })
    },[stampPage,stampOfficial])

    useEffect(() => {
        const comment = imageReplyInfo.length > 0
        const prompt = imageInfo.detail.find(d => d.prompt != "") !== undefined
        if(comment){
            setTabKey("comment")
        } else if(prompt){
            setTabKey("info")
        } else {
            setTabKey("comment")
        }
    },[imageInfo,imageReplyInfo])

    useEffect(() => {
        if(imageReplyPage > 1){
            getImageReply(groupId,"",imageReplyPage).then(r=>{
                if(r.result){
                    setImageReplyInfo(imageReplyInfo.concat(r.detail))
                }
            })
        }
    },[imageReplyPage])

    useEffect(() => {
        if(imageReplyPage > 0){
            getImageReply(groupId,"",imageReplyPage).then(r=>{
                if(r.result){
                    setImageReplyInfo(r.detail)
                } else {
                    setImageReplyInfo([])
                }
            })
        }
    },[deleted])

    useEffect(() => {
        /*getImageList(imagePage).then(r=>{
            if(r.result){
                setImageList(imageList.concat(r.data))
            }
        })*/
    },[imagePage])

    useEffect(() => {
        if(favoriteUserListPage > 1){
            getFavoriteUserList(groupId,favoriteUserListPage).then(r=>{
                if(r.result){
                    setFavoriteUserList(favoriteUserList.concat(r.data))
                }
            })
        }
    },[favoriteUserListPage])

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".replyLazy").forEach(e => observer.observe(e))
    },[imageInfo,imageReplyInfo,view,groupId,deleted])

    useEffect(() => {
        document.querySelectorAll(".lazy-popup").forEach(e => observer.observe(e))
        //document.querySelectorAll(".lazy-hidden").forEach(e => observer.observe(e))
    },[groupId])

    const list = [
        {isAd:true,to:"https://www.dlsite.com/home/dlaf/=/t/i/link/work/aid/ourt/id/RJ01099063.html",
        img:"//img.dlsite.jp/modpub/images2/work/doujin/RJ01100000/RJ01099063_img_main.jpg",
        title:"【ASMR】お狐様と双子の姉狐様【耳かき/尻尾耳かき/雨音/オノマトペ 声:丹下桜、こりす】",
        circle:"癒しの森の家"}
    ]
    const listR18 = [
        {isAd:true,to:"https://www.dlsite.com/maniax/dlaf/=/t/i/link/work/aid/ourt/id/RJ01104045.html",
        img:"//img.dlsite.jp/modpub/images2/work/doujin/RJ01105000/RJ01104045_img_main.jpg",
        title:'本当に深い耳奥"スタンプ"舐め ～お耳の奥に舌先をぐいぐい押し当てる≪深層圧着ASMR≫～',
        circle:"パステル×トリップ"}
    ]
    const [adList,setAdList] = useState([])

    useEffect(() => {
        if(searchImage === 0 || imageInfo.info.id === "") return
        let info = imageInfo.info
        let genre = ""
        if(info.age_limit === 1){
            genre = "general"
        } else if(info.age_limit === 2) {
            genre = "pg12"
        } else if(info.age_limit === 3) {
            genre = "r15"
        } else if(info.age_limit === 4) {
            genre = "r18"
        } else if(info.age_limit === 5) {
            genre = "r18g"
        }
        if(showKanren){
            if(info.tags && info.tags.length > 0){
                let tag = info.tags[Math.floor(Math.random() * info.tags.length)]
                setTag(tag)
                search("",[{value:1,checked:info.style_of_painting === 1},{value:2,checked:info.style_of_painting === 2},{value:3,checked:info.style_of_painting === 3}],
                    [
                        {"name": "全年齢","value": 1,"checked": info.age_limit === 1},
                        {"name": "PG-12","value": 2,"checked": info.age_limit === 2},
                        {"name": "R-15","value": 3,"checked": info.age_limit === 3},
                        {"name": "R-18","value": 4,"checked": info.age_limit === 4},
                        {"name": "R-18G","value": 5,"checked": info.age_limit === 5}
                    ],"3",[{value: 1,checked:0}],[],[],[tag],
                    [{"order": "random"}],1).then(r=>{
                    if(r.result){
                        setImageList([].concat(r.data))
                    }
                })
            } else {
                // 最新の画像を取得する場合はこれ
                let styles = ["illustration","photorealistic","semirealism"]
                let style = styles[info.style_of_painting-1]
                getImageList(style,genre,imagePage).then(r=>{
                    if(r.result){
                        setImageList([].concat(r.data))
                    }
                })
            }
            // 過去3ヵ月間の平均閲覧数の多いユーザ
            get3MonthAvg().then(r => {
                if(r.result){
                    setLast3MonthAvgList(r.data)
                }
            })
        }
    },[imageInfo,showKanren])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    window.onresize = () => {
        /*let width = document.getElementById("#"+imageInfo.detail[0].id).naturalWidth
        let height = document.getElementById("#"+imageInfo.detail[0].id).naturalHeight
        if(width > height){
            setWidth(window.innerWidth*0.8)
            setHeight(window.innerHeight*parseFloat(height)/parseFloat(width))
        } else {
            setWidth(window.innerWidth*parseFloat(width)/parseFloat(height))
            setHeight(window.innerHeight*0.8)
        }*/
    }

    // フォロー解除確定・コメント削除OKボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            if(item.type === "follow"){
                followDelete(imageInfo.info.user_id,dialog).then(r=>{
                    if(r){
                        setFollow(false)
                    }
                    setOkButtonShow(false)
                })
            } else if(item.type === "image_reply") {
                deleteImageReply(groupId,item.id).then(r=>{
                    if(r.result){
                        setDeleted(item.id)
                    } else {
                        dialog("エラー",r.errors)
                    }
                    setOkButtonShow(false)
                })
            }
        }}>OK</Button>
    }

    function selectImg(index,ext){
        // gif 1枚だけなら直接再生する
        if(imageInfo.detail.length === 1 && ext === "gif"){
            if(limitDiv !== "public"){
                if(limitedDataList.length > 0 && limitedDataList.length > index && undefined !== limitedDataList[index]){
                    return limitedDataList[index].t_m_webp
                } else {
                    return ""
                }
            } else {
                return ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/post/s/"+imageInfo.detail[index].id+".webp"
            }
        } else {
            if(limitDiv !== "public"){
                if(limitedDataList.length > 0 && limitedDataList.length > index && undefined !== limitedDataList[index]){
                    return limitedDataList[index].t_m_webp
                } else {
                    return ""
                }
            } else {
                return ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/post/t/"+imageInfo.detail[index].id+"_m"+ApiFetch.API_THUMB_EXT
            }
        }
    }

    function selectThumbnail(index,id){
        if(limitDiv === "public"){
            return ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/post/t/"+id+ApiFetch.API_THUMB_EXT
        } else {
            if(limitedDataList.length > 0 && limitedDataList.length > index && undefined !== limitedDataList[index]){
                return limitedDataList[index].t_webp
            } else {
                return ""
            }
        }
    }

    useEffect(() => {
        if(view) {
            setDetailNo(0)
        } else {
            let child = document.querySelector(".root")
            if(child === null) return
            zoomable(child)
            moveable(child)
            resettable(child,setEvents)
            resetPosition()
            child.addEventListener("mousedown",(e) => {
                child.dataset.start = new Date().getTime()
            })
            child.addEventListener("mouseup",(e) => {
                if(new Date().getTime() - child.dataset.start < 100){
                    setZoomMode(false)  
                }
            })
        }
    },[view,zoomMode,imageInfoStatus])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(false)
    const [showEditPopup,setShowEditPopup] = useState(false)
    const [title,setTitle] = useState("")
    const [description,setDescription] = useState("")
    const [viewListIndex,setViewListIndex] = useState(props.i || 0)
    const [viewList,setViewList] = useState(props.list || [])
    const [viewListName,setViewListName] = useState(props.listName || "")
    const [last3MonthAvg,setLast3MonthAvgList] = useState([])
    const [showPointSend,setShowPointSend] = useState(false)
    const [sensitiveShow,setSensitiveShow] = useState(false)
    const [showDisplaySetting,setShowDisplaySetting] = useState(false)

    // 言語設定
    const {language,setLanguage} = useContext(LanguageCtx)
    useEffect(() => {
        if(language === "ja"){
            setTitle(imageInfo.info.title)
            setDescription(imageInfo.info.description)
        } else if(language === "en"){
            if(imageInfo.info.title_en && imageInfo.info.title_en.length > 0){
                setTitle(imageInfo.info.title_en)
            } else {
                setTitle(imageInfo.info.title)
            }
            if(imageInfo.info.description_en && imageInfo.info.description_en.length > 0){
                setDescription(imageInfo.info.description_en)
            } else {
                setDescription(imageInfo.info.description)
            }
        }
    },[language,imageInfo])

    const keyEvent = (e) => {
        if(e.key === "Escape"){
            props.switch(false)
        }
        if(e.key === "Enter"){
            navigate("/image/"+groupId)
        }
        if(e.key === "ArrowLeft" || e.key === "ArrowRight"){
            imageMove(e.key === "ArrowLeft" ? "prev" : "next")
        }
    }
    document.onkeydown = keyEvent
    function imageMove(key){
        if(imageInfo.detail.length === 0) return
        if(key === "prev"){
            if(detailNo > 0){
                let detail = imageInfo.detail[detailNo-1]
                document.querySelector(".mainImage").src = selectImg(detailNo-1,detail.ext)
                setDetailNo(detailNo-1)
            } else if(detailNo === 0) {
                if(viewList.length !== 0 && viewListIndex > 0){
                    setGroupId(viewList[viewListIndex-1].group_id)
                    setViewListIndex(viewListIndex-1)
                    setDetailNo(0)
                    // 作品が変更される場合はセンシティブ再判定のため、ズームモードオフ
                    setZoomMode(false)
                    setView(false)
                } else {
                    let detail = imageInfo.detail[imageInfo.detail.length-1]
                    document.querySelector(".mainImage").src = selectImg(imageInfo.detail.length-1,detail.ext)
                    setDetailNo(imageInfo.detail.length-1)
                }
            }
        } else if(key === "next"){
            if(imageInfo.detail.length > detailNo + 1){
                let detail = imageInfo.detail[detailNo+1]
                document.querySelector(".mainImage").src = selectImg(detailNo+1,detail.ext)
                setDetailNo(detailNo+1)
            } else if(imageInfo.detail.length === detailNo + 1){
                if(viewList.length !== 0 && viewList.length > viewListIndex + 1){
                    setGroupId(viewList[viewListIndex+1].group_id)
                    setViewListIndex(viewListIndex+1)
                    setDetailNo(0)
                    // 作品が変更される場合はセンシティブ再判定のため、ズームモードオフ
                    setZoomMode(false)
                    setView(false)
                } else {
                    let detail = imageInfo.detail[0]
                    document.querySelector(".mainImage").src = selectImg(0,detail.ext)
                    setDetailNo(0)
                }
            }
        }
    }

    function setSwipe(elem) {
        let t = document.querySelector(elem);
        let startX;		// タッチ開始 x座標
        let startY;		// タッチ開始 y座標
        let moveX;	// スワイプ中の x座標
        let moveY;	// スワイプ中の y座標
        let dist = 200;	// スワイプを感知する最低距離（ピクセル単位）
        
        // タッチ開始時： xy座標を取得
        t.addEventListener("touchstart", function(e) {
            e.preventDefault()
            startX = e.touches[0].pageX
            startY = e.touches[0].pageY
        });
        
        // スワイプ中： xy座標を取得
        t.addEventListener("touchmove", function(e) {
            e.preventDefault()
            moveX = e.changedTouches[0].pageX
            moveY = e.changedTouches[0].pageY
        });
        
        // タッチ終了時： スワイプした距離から左右どちらにスワイプしたかを判定する/距離が短い場合何もしない
        t.addEventListener("touchend", function(e) {
            if (startX > moveX && startX > moveX + dist) {		// 右から左にスワイプ
                // 右から左にスワイプした時の処理
                imageMove("next")
            }
            else if (startX < moveX && startX + dist < moveX) {	// 左から右にスワイプ
                // 左から右にスワイプした時の処理
                imageMove("prev")
            }
        });
    }


        let img;
        let icon;
        let followButton

        /**
         * 以下の場合フォローボタンを表示しない
         * 投稿者本人の場合
         * 投稿者が匿名の場合
         */
        if(!(loginInfo.userId === imageInfo.info.user_id) && imageInfo.info.user_id !== "anonymous"){
            if(follow){
                followButton = <MuiButton className='m-1' variant='outlined' color="error" onClick={(e) => {
                    selectItem({type:"follow"})
                    setOkButtonShow(true)
                    dialog("確認",t("common.unfollow"))
                }}><Icon.PersonDash /></MuiButton>
            } else {
                followButton = <MuiButton className='m-1' variant='contained' color="error" onClick={(e) => {
                    if(loginInfo.result === false){
                        dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)
                        return
                    }
                    if(loginInfo.userId === imageInfo.info.user_id){
                        dialog("エラー","自分自身はフォローできません。")
                        return
                    }
                    followPost(imageInfo.info.user_id,dialog).then(r => {
                        if(r){
                            setFollow(true)
                        }
                    })
                }}>{t("common.followUs")}</MuiButton>
            }
        }
        if(imageInfoStatus){
            if(imageDisplayFlag === 0 && imageInfo.detail.length > 0 && imageInfo.detail[detailNo]){
                img = <Image id={"#img"+0} loading="eager" src={selectImg(0,imageInfo.detail[0] && imageInfo.detail[0].ext)} style={{filter:!sensitiveShow && (imageInfo.info.sensitive_flag === 1 || imageInfo.info.sensitive_flag === 2) ? "blur(100px)" : "none",objectFit:"contain",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="p-2 mainImage" onClick={() => setView(true)} onContextMenu={(e) => e.preventDefault()} />
            } else if(imageDisplayFlag === 1) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>PG-12指定作品<br />PG-12指定作品を表示する場合、<br /><span style={{cursor:"pointer",textDecoration:"underline"}} onClick={() => dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)}>ログイン</span>して設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 2) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-15指定作品<br />R-15指定作品を表示する場合、<br /><span style={{cursor:"pointer",textDecoration:"underline"}} onClick={() => dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)}>ログイン</span>して設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 3) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18指定作品<br />R-18指定作品を表示する場合、<br /><span style={{cursor:"pointer",textDecoration:"underline"}} onClick={() => dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)}>ログイン</span>して設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 4) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18G指定作品<br />R-18G指定作品を表示する場合、<br /><span style={{cursor:"pointer",textDecoration:"underline"}} onClick={() => dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)}>ログイン</span>して設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 5) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>PG-12指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else if(imageDisplayFlag === 6) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-15指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else if(imageDisplayFlag === 7) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else if(imageDisplayFlag === 8) {
                img = <div style={{position:"relative",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18G指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else {
                img = ""
            }
        } else {
            if(props.detailId === undefined){
                //img = <Image src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/post/t/'+(groupId)+"_in"+ApiFetch.API_THUMB_EXT} style={{objectFit:"contain",position:"absolute",width:"100%",height:"100%",borderRadius:"20px",cursor:"pointer"}} className="p-0" />
            } else {
                //img = <Image src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/post/t/'+(props.detailId)+"_m"+ApiFetch.API_THUMB_EXT} style={{objectFit:"contain",position:"absolute",width:"100%",height:"100%",borderRadius:"20px",cursor:"pointer"}} className="p-0" />
            }
        }
        let versions = {
            "1D44365E":"NAI Diffusion Anime (Curated)",
            "81274D13":"NAI Diffusion Anime (Full)",
            "1D09D794":"NAI Diffusion Furry (Beta V1.3)",
            "04c147f2":"v1.1 full ema",
            "4567aa0f":"v1.1",
            "11d755f8":"v1.2 full ema",
            "5e18682b":"v1.2",
            "ec706de4":"v1.3 full ema",
            "3706d7ad":"v1.3",
            "06c50424":"v1.4 full ema",
            "7460a6fa":"v1.4",
            "84692140":"v1.3 float16",  // Waifu Diffusion
            "4470c325":"v1.3 float32",
            "e1de58a9":"v1.3 full",
            "3e1a125f":"v1.3 full opt", // Waifu Diffusion
            "e2ec4647":"16",            // HentaiDiffusion
            "3a0cfc1c":"17",            // HentaiDiffusion
            "abaf1da6":"half",          // ACertainModel-half
            "27bd26ec":"half",          // ACertainThing-half
            "b5c0b653":"V2.2 (Anime)",  // Protogen V2.2 (Anime)
            "fde2460c":"V1.0",          // ourtAI Diffusion V1.0
            "4048130a":"V2.0",          // Counterfeit V2.0
            "8838e0d1fb":"V2.0",        // Counterfeit V2.0
            "f3b033b02f":"V2.0",        // Counterfeit V2.0
            "71e703a0fc":"V2.5",        // Counterfeit V2.5
            "fc9d6d1ff2":"v1.0 fp16",   // SukiyakiMix v1.0
            "6e350084a6":"anime_3.1_A", // 7th_anime_3.1_A
            "a916690d6d":"Anime V1",    // ourt AI Diffusion Anime V1
            "7a5574856e":"Anime V2",    // ourt AI Diffusion Anime V2
            "09184cfb61":"Anime V3",    // ourt AI Diffusion Anime V3
            "c53b90ad34":"Anime V3.5",  // ourt AI Diffusion Anime V3.5
            "1b5f8211ec":"v1.0 F16",    // Aurora v1.0 F16
            "6772b99463":"v9b",         // blue_pencil_v9b
            "3a105af1a6":"v10",         // blue_pencil_v10
            "0fd9832365":"EX",          // blue_pencil_EX
            "b1fce039e2":"V1",          // milktea_mild_V1
            "e4a30e4607":"v6"           // majicmixRealistic_v6
        }
        let modelVersion = ""
        if(imageInfoStatus && imageInfo.detail.length > 0 && imageInfo.detail[detailNo] && versions[imageInfo.detail[detailNo].model_hash]){
            modelVersion = versions[imageInfo.detail[detailNo].model_hash]
        }
        const breakpointColumnsObj = {
            default: 9,
            1800: 8,
            1600: 7,
            1400: 6,
            1200: 5,
            992: 4,
            768: 3,
            576: 2,
        }
    const [events,setEvents] = useState([])
    const [showAdminMenu,setShowAdminMenu] = useState(false)
    function isSmartPhone() {
        if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
          return true;
        } else {
          return false;
        }
    }
    const theme = useTheme();
    return (
<div style={{position:"relative",zIndex:show ? 4 : theme.zIndex.appBar + 500}}>
    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",opacity:0.3,zIndex:4}}></div>
    <div onClick={() => {
        setZoomMode(false)
        document.onkeydown = keyEvent
        }} style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",opacity:0.8,zIndex:6,display:zoomMode ? "block" : "none"}}></div>

    {imageInfoStatus && imageDisplayFlag === 0 && imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ext ? <div className="root" style={{position:"fixed",zIndex:6,display:zoomMode ? "block" : "none",width:"auto",maxWidth:window && window.innerWidth * 0.8,height:"auto",maxHeight:window && window.innerHeight * 0.8}}><Image loading="eager" src={selectImg(detailNo,imageInfo.detail[detailNo].ext)} style={{filter:!sensitiveShow && (imageInfo.info.sensitive_flag === 1 || imageInfo.info.sensitive_flag === 2) ? "blur(100px)" : "none",width:"auto",height:"auto",cursor:"pointer"}} className="p-2 mainImage" onContextMenu={(e) => e.preventDefault()} /></div> : ""}
    <div className="zoom-notice" style={{position:"fixed",zIndex:5,bottom:0,right:0,display:window && window.innerWidth >= 1200 && zoomMode ? "block" : "none",color:"#FFFFFF",fontSize:"48px"}}>
        十字キー←→：前後の画像移動<br />
        マウスホイール：拡大縮小<br />
        ドラッグ&ドロップ：画像移動<br />
        Spaceキー：位置、大きさリセット<br />
        ダブルクリック：戻る
    </div>
    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",zIndex:500}}>
        <script type="text/javascript">
            amzn_assoc_ad_type = "link_enhancement_widget";
            amzn_assoc_tracking_id = "ourt-ai-22";
            amzn_assoc_linkid = "d065a900ce46e35d1230dbafd6b90f07";
            amzn_assoc_placement = "";
            amzn_assoc_marketplace = "amazon";
            amzn_assoc_region = "JP";
        </script>
        <script src="//ws-fe.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&Operation=GetScript&ID=OneJS&WS=1&MarketPlace=JP"></script>
        <div id="popup-view" className="wrapper" style={{position:"fixed",top:"1%",left:"1%",width:"98%",height:"98%",zIndex:5,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"20px"}}>
            <div style={{position:"fixed",backgroundColor:"#FFFFFF",left:"30px",zIndex:5,overflow:"auto",width:"100%",height:"auto"}}>
                {viewList.length !== 0 ? <>{viewListName + " " + (viewListIndex+1) + "/" + viewList.length} {imageInfo.info.title.substring(0,30)}</> : ""}
            </div>
            <MuiButton className='m-3' style={{position:"fixed",top:"20px",left:"14px",zIndex:5}} onClick={() => {document.onkeydown = (e) => {};props.switch(false)}}>{t("common.close")}</MuiButton>
            <MuiButton className='m-3' style={{position:"fixed",top:"20px",left:"88px",zIndex:5}} onClick={() => {
                navigator.clipboard.writeText(ApiFetch.API_PROTOCOL+"//"+window.location.host+"/image/"+groupId)
                dialog(t("common.confirm"),t("common.copied"))
            }}>{t("common.copy")}</MuiButton>
            <Link to={"/image/"+groupId} onClick={() => {document.onkeydown = (e) => {};props.switch(false)}}><MuiButton className='m-3' style={{position:"fixed",top:"20px",left:"190px",zIndex:1}}>{t("common.moveToImageInfo")}</MuiButton></Link>
            {viewList.length !== 0 ? (
                <>
                    <MuiButton variant='outlined' className='m-3' style={{position:"fixed",top:"65px",left:"14px",zIndex:1}} onClick={() => imageMove("prev")}>{t("common.prev")}</MuiButton>
                    <MuiButton variant='outlined' className='m-3' style={{position:"fixed",top:"65px",left:"96px",zIndex:1}} onClick={() => imageMove("next")}>{t("common.next")}</MuiButton>
                </>
            ) : ""}
            <span style={{position:"fixed",top:"80px",left:"200px",zIndex:1,fontSize:"24px"}}>{detailNo+1}/{imageInfo.detail.length}</span>
            <CommonDialog
            maxWidth="1200px"  // 管理者画面用に大きな幅を設定
            minWidth="600px"   // 最小幅も大きめに設定
            fullScreen={window.innerWidth < 1024} // タブレット以下でフルスクリーン
            open={show} onClose={() => setShow(false)} content={<><Alert severity='info' style={{display:dialogTitle.length > 0 ? "block" : "none"}}>{dialogTitle}</Alert><br />{dialogMessage}<br />{okButton}</>} />
            {showEditPopup ? <EditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
            {showPointSend && imageInfo.info.user_id ? <PointSend type="image" groupId={groupId} userId={imageInfo.info.user_id} userName={imageInfo.info.user_name} id_auth={imageInfo.info.id_auth} dialog={dialog} switch={setShowPointSend} /> : ""}
            {showDisplaySetting ? (
                <DynamicDialog width={300} height={120} switch={setShowDisplaySetting} content={
                    <div style={{backgroundColor:"inherit",width:"auto"}} className='p-0'>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onChange={(e) => {
                            updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setOmitContinuous(e.currentTarget.checked)
                        }} />
                        <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                    </InputGroup>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onChange={(e) => {
                            updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setTileMode(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.tileMode")} readOnly />
                    </InputGroup>
                    </div>
                }/>
            ) : ""}
            {imageDisplayFlag === 9 || imageDisplayFlag === 10 || imageDisplayFlag === 11 ? (
            <div className='text-center'>
                <Container style={{backgroundColor:"#EEEEEE"}} className='p-0'>
                    <div style={{maxHeight:"300px",overflow:"hidden"}}>
                        <Image loading="eager" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/post/t/"+groupId+"_out.webp"} style={{filter:!sensitiveShow && (imageInfo.info.sensitive_flag === 1 || imageInfo.info.sensitive_flag === 2) ? "blur(100px)" : "none",width:"100%",cursor:"pointer"}} onContextMenu={(e) => e.preventDefault()} />
                    </div>
                    <br />
                    {imageInfoStatus ? (
                        <UserAvatarWithLikes 
                            userId={imageInfo.info.user_id} 
                            size={80}
                            className="p-2"
                            linkTo={"/user/"+(imageInfo.info.display_id.length > 0 ? imageInfo.info.display_id : imageInfo.info.user_id) + "/plans"}
                        />
                    ) : (
                        <Image style={{width:"100px",height:"100px",borderRadius:"50px",cursor:"pointer"}} className="p-2" />
                    )}
                    <strong style={{margin:"auto 20px",wordWrap:"wrap"}}>{imageInfo.info.user_id !== "anonymous" ? imageInfo.info.user_name : "匿名ユーザ"}
                        <UserMark sms_auth={imageInfo.info.sms_auth} role={imageInfo.info.role} plan={imageInfo.info.plan} beginner={imageInfo.info.beginner} identity_confirmed={imageInfo.info.identity_confirmed} moderator_badge_display_flag={imageInfo.info.moderator_badge_display_flag} dialog={dialog} />
                    </strong>
                    <br />
                    <h5>{imageInfo.info.title}</h5>
                    {imageDisplayFlag === 11 ? "" : (<div style={{display:imageInfo.info.plan_list === undefined || imageInfo.info.plan_list.length === 0 ? "none" : "block"}}>
                    <Chip label="メンバー限定コンテンツ" color='secondary' className='m-3' />
                    <div style={{fontFamily:"Meiryo UI"}}>このコンテンツを閲覧するには、以下のいずれかのプランへの加入が必要です。</div>
                    <Container className='mt-5'>
                        <Grid container spacing={2} className='m-0'>
                        {imageInfoStatus && imageInfo.info.plan_list !== undefined && imageInfo.info.plan_list.map((d,i) => {
                            return <Plan key={i} data={d} xs={12} sm={12} md={6} lg={4} xl={3} xxl={3} />
                        })}
                        </Grid>
                    </Container>
                    </div>)}
                    {limitDiv === "ourt" ? (
                        <OfficialPlanCards
                            isRRated={imageInfo.info.age_limit >= 3} 
                            dialog={dialog} 
                            loginInfo={loginInfo} 
                        />
                    ) : ""}
                    {imageDisplayFlag === 9 && (imageInfo.info.plan_list !== undefined && imageInfo.info.plan_list.length > 0 || limitDiv === "ourt") ? "または投稿を単品で購入することができます。" : ""}
                    {imageDisplayFlag === 9 || imageDisplayFlag === 11 ? (<div className='mb-5'>
                        <Chip label={<>投稿を単品購入 ￥{imageInfo.info.unit_amount}</>} color='secondary' className='m-3' />
                        <BuyConfirmDialog data={{
                            "id": groupId,
                            "buy_div": "IMAGE",
                            "name":imageInfo.info.title,
                            "user_name":imageInfo.info.user_name,
                            "amount":imageInfo.info.unit_amount,
                            "official":false
                        }} /></div>
                    ) : ""}
                </Container>
            </div>
            ) : ""}
            {view ? (
            <DynamicDialog width={window.innerWidth > window.innerHeight ? window.innerHeight  : window.innerWidth} height={window.innerHeight} switch={setView} content={
                <div className='d-flex justicy-content-center flex-wrap'>
                {imageInfo.detail.map((d,i) => {
                    return <Image key={i} loading="lazy" src={selectImg(i,d.ext)} style={{width:"100%",cursor:"pointer",display:"block"}} className="p-2" onClick={() => {
                        setView(false)
                    }} onContextMenu={(e) => e.preventDefault()} />
                })}
                </div>
            } />
            ) : ""}
            <div style={{marginTop:"110px",width:"98%"}}>
                {loginInfo.result === undefined || loginInfo.result ? "" : (
                    <Link to="/upload/image/generate" className='d-flex justify-content-center'><SBAlert className="m-3 p-2 text-center" style={{display:"inline-block"}}>無料で画像生成してみよう！<br /><Image src="/img/generate_512x256.webp" width={320} /></SBAlert></Link>
                )}
                <Row>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <Container className='p-0' style={{position:"relative",width:"auto",height:"auto",padding:0,textAlign:"center"}}>
                        <p style={{position:"absolute",top:"0",fontSize:"24px",display:imageDisplayFlag === 0 && !sensitiveShow && (imageInfo.info.sensitive_flag === 1 || imageInfo.info.sensitive_flag === 2) ? "block":"none"}}>この作品はセンシティブなものとして設定されています。</p>
                        <Button variant='secondary'
                        onClick={() => setSensitiveShow(true)}
                        style={{position:"absolute",top:"80px",fontSize:"24px",zIndex:2,display:imageDisplayFlag === 0 && !sensitiveShow && imageInfo.info.sensitive_flag === 1 ? "block":"none"}}>表示する</Button>
                        {imageDisplayFlag === 0 && imageInfo.detail.length > 0 ? (
                            imageInfo.detail.map((d,i) => {
                                d.no = i
                                return d
                            }).filter(d => (!view && imageInfo.detail[detailNo] && d.id === imageInfo.detail[detailNo].id) || (view)).map((detail,j) => {
                                return <Image key={j} id={"#"+detail.no} loading="eager" src={selectImg(detail.no,detail.ext)} style={{filter:!sensitiveShow && (imageInfo.info.sensitive_flag === 1 || imageInfo.info.sensitive_flag === 2) ? "blur(100px)" : "none",width:"auto",maxWidth:"100%",height:"auto",maxHeight:window.innerHeight * 0.8,cursor:"pointer"}} className="p-2 mainImage" onClick={() => {                                
                                    setDetailNo(detail.no)
                                    if(window.innerWidth >= 1200){
                                        setZoomMode(true)
                                    } else {
                                        setView(true)
                                        document.querySelectorAll("#root").forEach(e => e.classList.remove("touchnone"))
                                    }
                                }} onContextMenu={(e) => e.preventDefault()} />
                            })
                        ) : img}
                        {imageDisplayFlag === 0 && imageInfoStatus && imageInfo.detail.length > 1 ? <Container className='p-0 m-1 mb-2' style={{cursor:"pointer",display:view ? "none" : "block"}} onClick={() => setView(true)}>
                            <Container style={{padding:"5px",width:"100%",fontSize:"24px",fontWeight:"bold",borderRadius:"25px",border:"1px solid #000000",textAlign:"center",backgroundColor:"#FFFFFF",cursor:"pointer",display:view ? "none" : "block"}}>すべて表示</Container>
                        </Container> : ""}
                    </Container>
                    {imageDisplayFlag === 0 && imageInfoStatus && imageInfo.detail.length > 1 ? (
                    <Container className="d-flex justify-content-start align-items-center p-0" style={{flexWrap:"wrap",width:"100%",backgroundColor:"#FFFFFF",border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                        {imageInfo.detail.map((d,i) => {
                            return (
                                <div style={{flexShrink:0,width:"100px",height:"100px",overflow:"hidden"}} className="m-1" key={d.id}>
                                    <Image loading="lazy" src={selectThumbnail(i,d.id)} style={{filter:!sensitiveShow && (imageInfo.info.sensitive_flag === 1 || imageInfo.info.sensitive_flag === 2) ? "blur(100px)" : "none",objectFit:"cover",width:"100%",height:"100%",cursor:"pointer",backgroundColor:detailNo === i ? "#FFFFFF" : "inherit",opacity:detailNo === i ? "0.3" : "1"}} onClick={() => {
                                        document.querySelector(".mainImage").src = selectImg(i,d.ext)
                                        setDetailNo(i)
                                    }} onContextMenu={(e) => e.preventDefault()} />
                                </div>
                            )
                        })}
                    </Container>
                    ) : ""}
                </Col>
                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                {
                    // タイトル情報など
                }
                <Container className='p-0' style={{display:imageDisplayFlag === 9 || imageDisplayFlag === 10 || imageDisplayFlag === 11 ? "none" : "block"}}>
                    <LinearProgress hidden={limitDiv == "public" ? imageInfoStatus : limitedDataList.length === imageInfo.detail.length} />
                    <Container className='p-0' style={{fontWeight:"bold",fontSize:"21px"}}>
                        {showAdminMenu ? <DynamicDialog switch={setShowAdminMenu} width={450} height={180} content={
                        <Container style={{width:"400px",border:"1px solid red"}} className="mb-3 p-3">
                            <Form.Select className="mb-3" value={adminSelectItem} style={{}}
                                onChange={(e) => setAdminSelectItem(e.currentTarget.value)}
                            >
                                <option value="年齢制限" disabled>【年齢制限】</option>
                                <option value="allAges">全年齢(性表現なし)</option>
                                <option value="pg12">PG-12</option>
                                <option value="pg12Notice">PG-12 注意喚起あり</option>
                                <option value="r15">R-15</option>
                                <option value="r15Notice">R-15 注意喚起あり</option>
                                <option value="r18">R-18</option>
                                <option value="r18Notice">R-18 注意喚起あり</option>
                                <option value="r18g">R-18G</option>
                                <option value="r18gNotice">R-18G 注意喚起あり</option>
                                <option value="mosaicNotice" style={{color:"red"}}>隠蔽処理するように是正要求と公開停止(再公開は要審査)</option>
                                <option value="childPornNotice" style={{color:"red"}}>児童ポルノまたは類似表現の是正要求と公開停止(再公開は要審査)</option>
                                <option value="" disabled>-------------------------------------------</option>
                                <option value="画風" disabled>【画風】</option>
                                <option value="illust">イラスト</option>
                                <option value="semi">セミリアル</option>
                                <option value="photo">フォト</option>
                                <option value="" disabled>-------------------------------------------</option>
                                <option value="アカウント" disabled>【アカウント】</option>
                                <option value="search_ban" style={{color:"red"}}>新着や検索から除外</option>
                                <option value="ai_generate_suspend" style={{color:"red"}}>AI生成機能の利用制限措置</option>
                                <option value="account_suspend" style={{color:"red"}}>一時停止(利用規約違反)</option>
                                <option value="account_suspend_child_porn_post" style={{color:"red"}}>一時停止(児童ポルノまたは類似物の投稿)</option>
                                <option value="account_suspend_child_porn_generate" style={{color:"red"}}>一時停止(児童ポルノまたは類似物の生成)</option>
                                <option value="account_suspend_copyright" style={{color:"red"}}>一時停止(著作権侵害)</option>
                                <option value="account_permanently_frozen" style={{color:"red"}}>永久凍結</option>
                            </Form.Select>
                            <MuiButton variant='contained' style={{}}
                                onClick={() => {
                                    if(adminSelectItem === "illust" || adminSelectItem === "semi" || adminSelectItem === "photo"){
                                        updateStyleOfPaintingByAdmin(groupId,adminSelectItem).then(r => {
                                            if(r.result){
                                                dialog("確認","画風を「"+r.data.styleReturn+"」に更新しました。")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    } else if(adminSelectItem === "mosaicNotice") {
                                        sendMosaicNoticeByAdmin(groupId).then(r => {
                                            if(r.result){
                                                dialog("確認","モザイク是正要求通知を登録しました。")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    } else if(adminSelectItem === "childPornNotice") {
                                        sendChildPornNoticeByAdmin(groupId).then(r => {
                                            if(r.result){
                                                dialog("確認","児童ポルノまたは類似表現の是正要求通知を登録しました。")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    } else if(adminSelectItem.startsWith("account_suspend") || adminSelectItem === "account_permanently_frozen"){
                                        let status = -1
                                        let reason = -1
                                        if(adminSelectItem === "account_suspend"){
                                            status = 3 // 一時停止
                                            reason = 1 // 利用規約違反
                                        } else if(adminSelectItem === "account_suspend_child_porn_post"){
                                            status = 3 // 一時停止
                                            reason = 2 // 写実的な児童ポルノコンテンツの投稿
                                        } else if(adminSelectItem === "account_suspend_child_porn_generate"){
                                            status = 3 // 一時停止
                                            reason = 3 // 写実的な児童ポルノコンテンツの生成
                                        } else if(adminSelectItem === "account_suspend_copyright"){
                                            status = 3 // 一時停止
                                            reason = 4 // 著作権侵害
                                        } else if(adminSelectItem === "account_permanently_frozen") {
                                            status = 4 // 永久凍結
                                        }
                                        updateStatusByAdmin(imageInfo.info.user_id,status,reason).then(r => {
                                            if(r.result){
                                                dialog("確認","アカウントを「"+r.data.accountReturn+"」しました。")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    } else if(adminSelectItem === "search_ban"){
                                        searchBanByAdmin(imageInfo.info.user_id).then(r => {
                                            if(r.result){
                                                dialog("確認","新着や検索から除外しました。")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    } else if(adminSelectItem === "ai_generate_suspend"){
                                        aiGenerateSuspendByAdmin(imageInfo.info.user_id).then(r => {
                                            if(r.result){
                                                dialog("確認","AI生成機能の利用を制限しました。")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    } else {
                                        updateAgeLimitByAdmin(groupId,adminSelectItem).then(r => {
                                            if(r.result){
                                                dialog("確認","年齢制限を「"+r.data.ageLimitReturn+"」に更新しました。")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    }
                                }}
                            >実行(管理者権限)</MuiButton>
                            <MuiButton variant='contained' style={{marginLeft:"10px"}} onClick={() => dialog("",<UserManageInfo userIdOrDisplayId={imageInfo.info.user_id} dialog={dialog} change={groupId} />)}>管理情報</MuiButton>
                        </Container>
                        } /> : ""}
                        {loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") ? <Icon.PersonVcard className='m-3' style={{fontSize:"24px",cursor:"pointer"}} onClick={() => setShowAdminMenu(true)} />: ""}
                        {parse(title.replace(/[#＃]{1}([Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-・]?[^　 #＃\r\n]+)/g,'<span tag="$1">$1</span>'),{replace:tagReplace})}
                    </Container>
                    <Container className='p-0' style={{color:"#555555"}}>{imageInfo.info.booking_datetime === "0000-00-00 00:00:00" ? imageInfo.info.create_datetime : imageInfo.info.booking_datetime} {t("common.posted")}{imageInfo.info.booking_flag ? "(予約)" : ""} <Icon.Eye></Icon.Eye> {pv}
                        {showFavoriteUserList ? (
                        <DynamicDialog width={window.innerWidth > window.innerHeight ? window.innerHeight  : window.innerWidth} height={window.innerHeight} switch={setShowFavoriteUserList} content={
                            <Container>
                                <h3>{t("common.likedUsers")}</h3>
                                <Button variant='outline-secondary' onClick={() => setShowFavoriteUserList(false)}>{t("common.close")}</Button>
                                <Row>
                                {favoriteUserList.map((d,i) => {
                                    return  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="p-1" key={i}>
                                                <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                                    <div className='d-flex justify-content-start'>
                                                        <div>
                                                            <UserAvatarWithLikes 
                                                                userId={d.follow_user_id} 
                                                                size={100} 
                                                                linkTo={"/user/"+d.follow_user_id}
                                                                className="lazy"
                                                                data-type="favorite" 
                                                                data-observe="0" 
                                                                data-no={i}
                                                            />
                                                        </div>
                                                        <div className='p-3'>
                                                            <Link to={"/user/"+d.follow_user_id} style={{textDecoration:"none",color:"#000000"}}><ruby> {d.user_name} <rp>(</rp><rt>{d.user_name_kana}</rt><rp>)</rp> </ruby></Link>
                                                            <UserMark sms_auth={d.sms_auth} role={d.role} plan={d.plan} beginner={d.beginner} identity_confirmed={d.identity_confirmed} moderator_badge_display_flag={d.moderator_badge_display_flag} dialog={dialog} />
                                                            <br />
                                                            {loginInfo.userId !== d.follow_user_id ? 
                                                            (<FollowButton userId={d.follow_user_id} follow={d.follow} userName={d.user_name} />)
                                                            : ""}
                                                        </div>
                                                    </div>
                                                    <p>{d.self_introduction}</p>
                                                </Container>
                                            </Col>
                                })}
                                </Row>
                            </Container>
                        } />) : ""}
                        &nbsp;
                        <span style={{cursor:"pointer"}} onClick={(e) => {
                            getFavoriteUserList(groupId,favoriteUserListPage).then(r => {
                                if(r.result){
                                    setFavoriteUserList(r.data)
                                    setShowFavoriteUserList(true)
                                }
                            })
                        }}>いいね {imageInfo.info.favorite_count}</span>
                        {false ? (<FavoriteIcon style={{cursor:"pointer",marginLeft:"20px",fontSize:"24px"}} type="image" id={groupId} favorite={imageInfo.info.favorite} dialog={dialog} count={-1} />) : ""}
                        <FavoriteIconV2 style={{cursor:"pointer",margin:"0 20px",fontSize:"20px"}} type="image" id={groupId} favorite={imageInfo.info.favorite} dialog={dialog} count={-1} />
                        <Clap style={{cursor:"pointer",margin:"0 10px 0 0",fontSize:"18px",userSelect: "none"}} type="image" id={groupId} count={imageInfo.info.clap_count} dialog={dialog} />
                        {imageInfo.info.style_of_painting === 1 ? (<Chip bg="secondary" className='m-1' label={t("upload.image.illustration")} />) : ""}
                        {imageInfo.info.style_of_painting === 2 ? (<Chip bg="secondary" className='m-1' label={t("upload.image.photorealistic")} />) : ""}
                        {imageInfo.info.style_of_painting === 3 ? (<Chip bg="secondary" className='m-1' label={t("upload.image.semirealism")} />) : ""}
                        {imageInfo.info.age_limit === 2 ? (<Chip bg="secondary" className='m-1' label={"PG-12"} />) : ""}
                        <br />
                        {imageInfo.info.age_limit === 3 ? (<Chip bg="danger" className='m-1' label="R-15" />) : ""}
                        {imageInfo.info.age_limit === 4 ? (<Chip bg="danger" className='m-1' label="R-18" />) : ""}
                        {imageInfo.info.age_limit === 5 ? (<Chip bg="danger" className='m-1' label="R-18G" />) : ""}
                        <Chip className='m-1' style={{display:imageInfo.detail[detailNo] && imageInfo.detail[detailNo].use_ai_generation === 1 ? "inline" : "none",cursor:"pointer"}}
                            label={<Link to={"/upload/image/generate"} style={{textDecoration:"none"}}>AI生成機能を使用</Link>}
                        />
                        &nbsp;
                        <Chip color="primary" style={{cursor:"pointer",padding:"5px",display:imageInfo.info.user_id === loginInfo.userId || (loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator")) ? "inline" : "none"}}
                            onClick={() => {
                                //navigate("/edit/"+groupId)
                                setShowEditPopup(true)
                            }} label={<><Icon.PencilSquare /> <span>{t("common.edit")}</span></>}
                        />
                        &nbsp;
                    </Container>
                    <Container className='d-flex flex-row justify-content-start flex-nowrap' style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                        <Container>
                            <Row className='d-flex justify-content-start'>
                                <Col xs={12} sm={9} md={9} lg={9} xl={9} xxl={9} style={{margin:"0 auto",overflow:"hidden"}} className='d-flex justify-content-start'>
                                    {imageInfoStatus ? (
                                        <UserAvatarWithLikes 
                                            userId={imageInfo.info.user_id} 
                                            size={50}
                                            className="p-2"
                                            linkTo={"/user/"+imageInfo.info.user_id}
                                            style={{cursor:"pointer"}}
                                        />
                                    ) : (
                                        <Image style={{width:"100px",height:"100px",borderRadius:"50px",cursor:"pointer"}} className="p-2" />
                                    )}
                                    <strong style={{margin:"auto 20px",wordWrap:"wrap"}}>{imageInfo.info.user_id !== "anonymous" ? imageInfo.info.user_name : "匿名ユーザ"}
                                    <UserMark sms_auth={imageInfo.info.sms_auth} role={imageInfo.info.role} plan={imageInfo.info.plan} beginner={imageInfo.info.beginner} identity_confirmed={imageInfo.info.identity_confirmed} moderator_badge_display_flag={imageInfo.info.moderator_badge_display_flag} dialog={dialog} />
                                    </strong>
                                    {followButton}
                                </Col>
                                <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='d-flex justify-content-start'>
                                    <Button variant='outline-danger' title='支援する'
                                    className='m-1'
                                    style={{display:loginInfo.userId === imageInfo.info.user_id || imageInfo.info.user_id === "anonymous" || imageInfo.info.user_id === undefined ? "none" : "block"}}
                                    onClick={() => setShowPointSend(true)}
                                    ><Icon.PersonHeart style={{fontSize:"24px"}} /></Button>

                                    <NavDropdown title={(
                                    <Icon.ThreeDots style={{fontSize:"24px"}} />
                                    )} id="report-dropdown" disabled={loginInfo.result === true && loginInfo.status !== 0} className='m-3'>
                                        <NavDropdown.Item className='p-0 text-center' style={{cursor:"pointer"}} onClick={() => 
                                            dialog(t("common.shareSNS"),
                                            <>
                                            <a href={url} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"2px 20px",borderRadius:"15px",backgroundColor:"#000000",color:"#FFFFFF",border:"1px solid #1D9BF0"}}>𝕏(旧Twitter)</a>
                                            &nbsp;&nbsp;&nbsp;
                                            <a href={urlAffi} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"2px 20px",borderRadius:"15px",backgroundColor:"#000000",color:"#FFFFFF",border:"1px solid #1D9BF0"}}>𝕏(旧Twitter) アフィリエイトリンク付き</a>
                                            </>
                                            )}>
                                            <Icon.ShareFill style={{marginLeft:"10px"}}
                                            /> 共有
                                        </NavDropdown.Item>
                                        {imageInfoStatus && imageInfo.info.limit_div === 'public' ? (
                                        <NavDropdown.Item className='p-0 text-center' style={{cursor:"pointer"}} onClick={() => {
                                              const a = document.createElement('a')
                                              // a.href = ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/post/s/'+imageInfo.detail[detailNo].id+".webp"
                                              a.href = ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/getImageSource/"+groupId+"/"+detailNo
                                              a.download = "ourt-ai.work_"+imageInfo.detail[detailNo].id+".webp"
                                              document.body.appendChild(a)
                                              a.click()
                                              document.body.removeChild(a)
                                        }}>
                                            <Icon.Download style={{fontSize:"18px"}} /> ダウンロード
                                        </NavDropdown.Item>
                                        ) : ""}
                                        <NavDropdown.Item className='p-0 text-center'><MuteButton mute={imageInfo.info.mute} userId={imageInfo.info.user_id} userName={imageInfo.info.user_name} /></NavDropdown.Item>
                                        <NavDropdown.Item className='p-0 text-center'
                                        onClick={() => {
                                            if(loginInfo.result === false){
                                                dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                                                return
                                            }
                                            dialog(t("common.reportAProblem"),<Report type="image" groupId={groupId} title={imageInfo.info.title} dialog={dialog} />)
                                        }}><Icon.ExclamationCircle /> {t("common.reportAProblem")}</NavDropdown.Item>
                                    </NavDropdown>
                                </Col>
                            </Row>
                            {imageInfo.info.user_id === "anonymous" ? (
                                    <div>
                                        <FloatingLabel controlId="delete-password" label="削除パスワード">
                                            <Form.Control type="password" cows="10" autoComplete="new-password" />
                                        </FloatingLabel>
                                        <Button onClick={(e) => {
                                            let delPass = document.getElementById("delete-password").value
                                            if(delPass.trim().length === 0){
                                                dialog("エラー","削除パスワードを入力してください。")
                                                return
                                            }
                                            deleteImage(groupId).then((r)=>{
                                                if(r.result){
                                                    dialog("確認","削除しました")
                                                } else {
                                                    dialog("エラー",r.errors)
                                                }
                                            })
                                        }}>削除</Button>
                                    </div>
                                ):""}
                        </Container>
                    </Container>
                    {imageDisplayFlag === 0 && imageInfo.info.plan_public_info ? <Container>
                    {imageInfo.info.plan_public_info.general
                    || imageInfo.info.plan_public_info.pg12 && loginInfo.pg12_display_flag === 1
                    || imageInfo.info.plan_public_info.r15 && loginInfo.r15_display_flag === 1 && loginInfo.age15 === 1
                    || imageInfo.info.plan_public_info.r18 && loginInfo.r18_display_flag === 1 && loginInfo.age18 === 1
                    || imageInfo.info.plan_public_info.r18g && loginInfo.r18g_display_flag === 1 && loginInfo.age18 === 1
                    ? <Chip label="メンバーになって限定コンテンツを見る" color='primary' className='w-100 m-2' variant='contained' onClick={() => navigate("/user/"+(imageInfo.info.display_id !== "" ? imageInfo.info.display_id : imageInfo.info.user_id)+"/plans")} /> : ""}
                    </Container> : ""}
                    <Container className='mb-3' style={{color:"#555555"}}>{parse(description.replace(/[#＃]{1}([Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-・]?[^　 #＃\r\n]+)/g,'<span tag="$1">$1</span>').replace(/\r\n|\r|\n/g,"<br />").replace(/https:\/\/ourt-ai\.work\/image\/([0-9a-z-]{36})/g,"<span href='$1/'>画像リンク</span><br />")
                    .replace(/(https?:\/\/[\w!?/+\-_~;.,*&@#$%()'=[\]]+)/g,'<a href="$1">$1</a>'),{replace:tagReplace})}</Container>
                    {imageInfoStatus  && questionId !== "" ? (
                        <QuestionAnswer
                            questionId={questionId}
                        />
                    ) : ""}
                    {imageInfoStatus && imageInfo.info.series && imageInfo.info.series.length > 0 ? (
                        <h5>シリーズ</h5>
                    ) : ""}
                    <Row className='m-0 mb-3'>
                    {imageInfoStatus && imageInfo.info.series && imageInfo.info.series.map((d,i) => {
                        let ageLimit = ["全年齢","PG-12","R15","R18","R18G"]
                        let id = d.info.display_id.length > 0 ? d.info.display_id : d.info.user_id
                        return  <Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6} className="p-0" key={i}>
                                    <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                        <Link to={"/series/"+id+"/"+d.info.series_link}>
                                            <Image data-type="series" data-observe="0" data-no={i} className="lazy-popup" loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/series/"+d.info.series_id+".webp?"+d.info.update_datetime} style={{width:"250px",height:"auto",borderRadius:"5px"}} /><br />
                                            {d.info.series_age_limit > 1 ? "["+ageLimit[d.info.series_age_limit-1]+"]" : ""}{d.info.series_name}<br />
                                        </Link>
                                    </Container>
                                </Col>
                    })}
                    </Row>
                </Container>
                <Container className='mt-4'>
                    {imageInfoStatus && imageInfo.info.character_list !== undefined && imageInfo.info.character_list.length > 0 ? "関連キャラクター" : ""}
                    <Grid container>
                        {imageInfoStatus && imageInfo.info.character_list !== undefined && imageInfo.info.character_list.map((d,i) => {
                            if(i === 50) return ""
                            return <CharacterProfileCard maxWidth={200} data={{display_id:"",group_id:d.character_id,user_id:d.user_id,follow:false,user_name:"",description:"",character_name:d.character_name,character_name_kana:d.character_name_kana}} />
                        })}
                    </Grid>
                </Container>
                {imageDisplayFlag === 0 ?
                <Container style={{display:"block"}} className="p-0 mb-3">
                    {imageReplyInfo.length === 0 ? <Alert severity='info' style={{cursor:"pointer"}} onClick={() => {
                        setTabKey("comment")
                        if(stampList.length > 0){
                            setStampList([])
                            setStampPage(0)
                        } else {
                            setStampPage(1)
                        }
                    }}>1件目のコメントをしてみませんか？<MuiButton variant='outlined'>コメントする</MuiButton></Alert> : ""}
                    <Tabs defaultActiveKey="comment" onSelect={(key) => {
                        setTabKey(key)
                        if(key === "other"){
                            // ユーザの投稿一覧を取得
                            getUserImageList(imageInfo.info.user_id,1).then(r => {
                                if(r.result){
                                    setUserImageList(r.data)
                                }
                            })
                        }
                    }} activeKey={tabKey}>
                        <Tab eventKey="comment" title={t("common.comments")}>
                            <Container className='p-0' style={{border:"1px solid #CCCCCC",borderTop:"none"}}>
                                <Row style={{display:"block",borderRadius:"5px",textAlign:"left",padding:"10px 5px",margin:"10px 0"}} className="w-100">
                                    <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{margin:"0 auto",width:"100%"}}>
                                        <FloatingLabel
                                        onFocus={() => {document.onkeydown = () => {}}}
                                        onBlur={() => {document.onkeydown = keyEvent}}
                                        onClick={(e) => {
                                            if(loginInfo.result === false){
                                                dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)
                                            }
                                        }}
                                        controlId="text" label="コメントを記載" className='mb-3 w-100' style={{lineHeight:"20px"}} onInput={(e) =>{
                                            let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                                            let n = e.nativeEvent.target.value.match(/\n/g)
                                            if(n === null){
                                                n = 1
                                            } else {
                                                n = n.length + 1
                                            }
                                            e.currentTarget.style.height = lineHeight * n + 30 + "px"
                                            document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                                        }}>
                                            <Form.Control
                                                className='textarea'
                                                as="textarea"
                                                style={{ width:"inherits",height: '50px' }}
                                                required
                                            />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{margin:"0 auto",width:"100%"}}>
                                        <MuiButton variant='outlined' onClick={() => {
                                            if(stampList.length > 0){
                                                setStampList([])
                                                setStampPage(0)
                                            } else {
                                                setStampPage(1)
                                            }
                                        }}>
                                        <RIcon.FaStamp style={{color:"#555555",cursor:"pointer",fontSize:"24px"}} /></MuiButton>&nbsp;
                                        <MuiButton variant='outlined' onClick={() => {
                                            if(loginInfo.result === false){
                                                dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                                                return
                                            }
                                            let text = document.getElementById("text")
                                            if(text.value.trim().length === 0){
                                                dialog("エラー","コメントを入力して下さい。")
                                                return
                                            }
                                            if(text.value.trim().length > 2500){
                                                dialog("エラー","コメントは2500文字以内にして下さい。")
                                                return
                                            }
                                            upload("image",document.getElementById("text").value,groupId)
                                        }}>{t("common.comment")}</MuiButton>
                                        {stampMessage}
                                        {stampList.length > 0 ? (
                                        <Container style={{border:stampList.length > 0 ? "1px solid #555555" : "none",borderRadius:"5px"}} className='mt-2'>
                                            <MuiButton onClick={() => {
                                                setStampOfficial(true)
                                                setStampPage(1)
                                            }} variant={stampOfficial ? 'contained' : "outlined"} className='m-3'>公式</MuiButton>
                                            <MuiButton onClick={() => {
                                                setStampOfficial(false)
                                                setStampPage(1)
                                            }} variant={!stampOfficial ? 'contained' : "outlined"} className='m-3'>保有</MuiButton>
                                            <Row>
                                                <Col style={{display:stampList.length > 0 ? "block" : "none",margin:"0 auto"}} className="m-1">
                                                    <Link to="/stampManage"><Icon.Plus style={{borderRadius:"5px",border:"3px solid #AAAAAA",fontSize:"64px",cursor:"pointer",width:"100px",height:"100px",margin:"0 auto"}} /></Link>
                                                </Col>
                                                {stampList.map((data,i) => {
                                                    if(i === 30){
                                                        return ""
                                                    }
                                                return <Col style={{margin:"0 auto"}} className="m-1" key={i}>
                                                            <Container style={{position:"relative",width:"100px",height:"100px"}} className="p-0">
                                                                {
                                                                // <Badge bg="white" style={{cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",right:"50px"}} onClick={() => navigate("/edit/"+data.group_id)}>
                                                                //     <Icon.PencilSquare style={{color:"#000000"}} /> <span style={{color:"#555555"}}>編集</span>
                                                                // </Badge>
                                                                // <FavoriteIcon type="image" id={data.group_id} style={{cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} favorite={data.favorite} dialog={dialog} />
                                                                }
                                                                <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="stamp" 
                                                                    onClick={() => {
                                                                        upload("image",document.getElementById("text").value,groupId,data.stamp_id)
                                                                        setStampList([])
                                                                        setStampPage(0)
                                                                    }}
                                                                    onMouseOver={(e) => {
                                                                        e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+ApiFetch.API_THUMB_EXT
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT
                                                                    }}
                                                                />
                                                            </Container>
                                                            <Container style={{fontWeight:"bold",fontSize:"15px"}}><Link to={"/image/"+(data.stamp_id)} style={{color:"#555555",textDecoration:"none"}}>{data.title}</Link></Container>
                                                        </Col>
                                                })}
                                            </Row>
                                            {stampList.length > 0 ? (
                                            <Container className='d-flex justify-content-between' style={{width:"200px"}}>
                                                {stampPage > 1 ? (
                                                        <Button onClick={() => {
                                                            let p = stampPage - 1
                                                            setStampPage(p)
                                                        } }>{t("common.prev")}</Button>
                                                    ) : <Button disabled>{t("common.prev")}</Button>}
                                                {stampList.length > 30 ? (
                                                        <Button onClick={() => {
                                                            let p = stampPage + 1
                                                            setStampPage(p)
                                                        } }>{t("common.next")}</Button>
                                                    ) : <Button disabled>{t("common.next")}</Button>}
                                            </Container>
                                            ) : ""}
                                        </Container>
                                        ) : ""}
                                    </Col>
                                </Row>
                                <Container style={{maxHeight:"300px",overflow:"auto"}}>
                                    {imageReplyInfo && imageReplyInfo.map((comment,i) => {
                                        return (
                                            <div key={i}>
                                                <Reply postType="image" groupId={groupId} comment={comment} i={i} imageInfo={imageInfo} upload={upload} selectItem={selectItem} setOkButtonShow={setOkButtonShow} dialog={dialog} keyEvent={keyEvent} />
                                                {comment.replyList.map((reply,j) => {
                                                    return (<Reply postType="image" key={j} type={"reply-sub"} groupId={groupId} comment={reply} i={j} imageInfo={imageInfo} upload={upload} selectItem={selectItem} setOkButtonShow={setOkButtonShow} dialog={dialog} keyEvent={keyEvent} />)
                                                })}
                                            </div>
                                        )
                                    })}
                                </Container>
                            </Container>
                        </Tab>
                        <Tab eventKey="info" title={t("common.info")}>
                            <Container className='p-3' style={{border:"1px solid #CCCCCC",borderTop:"none"}}>
                                {imageInfo.info.original === 1 ? (<Badge bg="secondary" className='m-1'><Icon.Brush /> {t("upload.image.original")}</Badge>) : ""}
                                {imageInfo.info.limited_publication === 1 ? (<Badge bg="secondary" className='m-1'><Icon.Eye /> {t("common.limited")}</Badge>) : ""}
                                <hr />
                                {imageInfoStatus && imageInfo.detail[detailNo] ?
                                    (<MuiButton className='m-1' variant='outlined' color='info' onClick={() => window.location.href = "/similarity/image/"+imageInfo.detail[detailNo].id}><Icon.Search />&nbsp;類似検索</MuiButton>)
                                :""}
                                <MuiButton variant='outlined' className='m-1' onClick={() => {
                                    copyTextToClipboard(
                                        "Prompt:\r\n"+imageInfo.detail[detailNo].prompt+"\r\n"
                                        + "Negative Prompt:\r\n"+imageInfo.detail[detailNo].negative_prompt+"\r\n"
                                        + "Model:"+imageInfo.detail[detailNo].ai_model+"\r\n"
                                        + "Steps:"+imageInfo.detail[detailNo].steps + " "
                                        + "Scale:"+imageInfo.detail[detailNo].scale + " "
                                        + "Seed:"+imageInfo.detail[detailNo].seed + " "
                                        + "Sampler:"+imageInfo.detail[detailNo].sampler + " "
                                        + "Strength:"+imageInfo.detail[detailNo].strength
                                    )
                                    dialog("確認",t("common.promptInfoCopied"))
                                }}>{t("common.promptInfoCopy")}</MuiButton>
                                {imageInfoStatus ? (
                                    <>
                                        <a href={"/upload/image/generate?id="+imageInfo.detail[detailNo].id}><MuiButton className='m-1' variant='outlined' color='primary'><Icon.Magic />&nbsp;引用生成</MuiButton></a>
                                        <MuiButton className='m-1' variant='outlined' color='warning' onClick={() => {
                                            navigator.clipboard.writeText("https://ourt-ai.work/upload/image/generate?id="+imageInfo.detail[detailNo].id)
                                            dialog(t("common.info"),"このプロンプトを引用生成するための共有リンクをクリップボードにコピーしました。")
                                        }}><Icon.Link />&nbsp;リンク共有</MuiButton>
                                    </>
                                ) : ""}
                                <FloatingLabel controlId="prompt" label={t("upload.image.prompt")} className="mb-3" style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].prompt && imageInfo.detail[detailNo].prompt.length > 0 ? "block":"none"}}>
                                    <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].prompt} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].prompt).then(() => dialog("確認","プロンプトをコピーしました。"))} style={{cursor:"pointer"}} />
                                </FloatingLabel>
                                <FloatingLabel controlId="negative-prompt" label={t("upload.image.negativePrompt")} className="mb-3" style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].negative_prompt && imageInfo.detail[detailNo].negative_prompt.length > 0 ? "block":"none"}}>
                                    <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].negative_prompt} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].negative_prompt).then(() => dialog("確認","ネガティブプロンプトをコピーしました。"))} style={{cursor:"pointer"}}/>
                                </FloatingLabel>
                                <Row>
                                    <Col xs={8} sm={5} md={4} lg={5} xl={4} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ai_model && imageInfo.detail[detailNo].ai_model !== "no-select" ? "block":"none"}}>
                                        <FloatingLabel controlId="ai-model" label={t("upload.image.useModel")} className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ai_model} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].ai_model).then(() => dialog("確認","AIモデルをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={12} sm={6} md={5} lg={7} xl={6} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].model_hash && modelVersion !== "" ? "block":"none"}}>
                                        <FloatingLabel controlId="model-version" label={t("upload.image.modelVersion")} className="mb-3">
                                            <Form.Control type="text" defaultValue={modelVersion} readOnly onClick={() => copyTextToClipboard(modelVersion).then(() => dialog("確認","モデルバージョンをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={4} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].steps && imageInfo.detail[detailNo].steps.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="steps" label="Steps" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].steps} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].steps).then(() => dialog("確認","Stepsをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={4} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].scale && imageInfo.detail[detailNo].scale.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="scale" label="Scale" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].scale} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].scale).then(() => dialog("確認","Scaleをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].seed && imageInfo.detail[detailNo].seed.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="seed" label="Seed" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].seed} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].seed).then(() => dialog("確認","Seedをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={9} sm={4} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].sampler && imageInfo.detail[detailNo].sampler.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="sampler" label="Sampler" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].sampler} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].sampler).then(() => dialog("確認","Sampleをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].strength && imageInfo.detail[detailNo].strength.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="strength" label="Strength" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].strength} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].strength).then(() => dialog("確認","Strengthをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].mask_blur && imageInfo.detail[detailNo].mask_blur.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="mask-blur" label="Mask blur" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].mask_blur} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].mask_blur).then(() => dialog("確認","Mask blurをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].clip_skip && imageInfo.detail[detailNo].clip_skip.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="clip-skip" label="Clip skip" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].clip_skip} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].clip_skip).then(() => dialog("確認","Clip Skipをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_enabled && imageInfo.detail[detailNo].controlnet_enabled.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="controlnet-enabled" label="ControlNet Enabled" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_enabled} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_enabled).then(() => dialog("確認","ControlNet Enabledをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_module && imageInfo.detail[detailNo].controlnet_module.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="controlnet-module" label="ControlNet Module" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_module} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_module).then(() => dialog("確認","ControlNet Moduleをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={8} sm={4} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_model && imageInfo.detail[detailNo].controlnet_model.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="controlnet-model" label="ControlNet Model" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_model} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_model).then(() => dialog("確認","ControlNet Modelをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_weight && imageInfo.detail[detailNo].controlnet_weight.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="controlnet-weight" label="ControlNet Weight" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_weight} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_weight).then(() => dialog("確認","ControlNet Weightをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ensd && imageInfo.detail[detailNo].ensd.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="ensd" label="ENSD" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ensd} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].ensd).then(() => dialog("確認","ENSDをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscale && imageInfo.detail[detailNo].hires_upscale.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="hires-upscale" label="Hires Upscale" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscale} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].hires_upscale).then(() => dialog("確認","Hires Upscaleをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={6} md={5} lg={5} xl={5} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscaler && imageInfo.detail[detailNo].hires_upscaler.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="hires-upscaler" label="Hires Upscaler" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscaler} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].hires_upscaler).then(() => dialog("確認","Hires Upscalerをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].raw_info && imageInfo.detail[detailNo].raw_info.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="raw-info" label="Raw Info" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].raw_info} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].raw_info).then(() => dialog("確認","Raw Infoをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={8} sm={8} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vae && imageInfo.detail[detailNo].vae.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="vae" label="VAE" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vae} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].vae).then(() => dialog("確認","VAEをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={8} sm={8} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].gpu && imageInfo.detail[detailNo].gpu.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="gpu" label="GPU" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].gpu} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].gpu).then(() => dialog("確認","GPUをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                    <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vram && imageInfo.detail[detailNo].vram.length > 0 ? "block":"none"}}>
                                        <FloatingLabel controlId="vram" label="VRAM" className="mb-3">
                                            <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vram} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].vram).then(() => dialog("確認","VRAMをコピーしました。"))} style={{cursor:"pointer"}} />
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                            </Container>
                        </Tab>
                        <Tab eventKey="other" title={t("common.otherPosts")}>
                            {userImageList.length > 0 ? (
                                <Container className='mt-3 mb-3 p-0'>
                                    <Container style={{width:"100%",height:"225px",maxHeight:"230px",padding:"5px",backgroundColor:"#FFFFFF",border:"1px solid #CCCCCC",borderRadius:"5px",overflow:"auto"}}>
                                        {userImageList.map((d,i) => {
                                            return (
                                                <div style={{position:"relative",float:"left"}} key={d.id}>
                                                    <div style={{width:"100px",height:"100px",overflow:"hidden",filter:(loginInfo.pg12_display_flag === 2 && d.age_limit === 2) || d.age_limit === 5 || d.sensitive_flag === 1 || d.sensitive_flag === 2 ? "blur(100px)" : "none"}} className="m-1">
                                                        <Image loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/post/t/"+d.group_id+"_in"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",width:"100%",height:"100%",cursor:"pointer",opacity:d.group_id === groupId ? "0.2" : ""}} onClick={() => {
                                                            setDetailNo(0)
                                                            setGroupId(d.group_id)
                                                        }} onContextMenu={(e) => e.preventDefault()} />
                                                    </div>
                                                    {d.limit_div !== "public" && d.plan_access === 0 ? <Badge style={{cursor:"pointer",position:"absolute",zIndex:"1",bottom:"10px",right:"16px"}}><LockIcon style={{fontSize:"24px"}} /></Badge> : ""}
                                                    {d.age_limit === 3 ? (<Badge bg="danger" className='m-1' style={{position:"absolute",top:"5px",left:"5px"}}> R-15</Badge>) : ""}
                                                    {d.age_limit === 4 ? (<Badge bg="danger" className='m-1' style={{position:"absolute",top:"5px",left:"5px"}}> R-18</Badge>) : ""}
                                                    {d.age_limit === 5 ? (<Badge bg="danger" className='m-1' style={{position:"absolute",top:"5px",left:"5px"}}> R-18G</Badge>) : ""}
                                                </div>
                                            )
                                        })}
                                    </Container>
                                </Container>
                            ) : ""}
                        </Tab>
                    </Tabs>
                    {/* PC向け */}
                    {loginInfo.plan === undefined || loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : imageInfoStatus && imageInfo.info.age_limit === 1 ? <AdSence /> : ""}
                    {loginInfo.plan === undefined || loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : (
                        !isSmartPhone() ? (<>
                            <div className='mt-3 d-none d-md-block'>
                                {imageInfoStatus && imageInfo.info.age_limit === 1 ? <div className='d-flex justify-content-start'><DLsite list={adList} imageList={imageList} /></div> : ""}
                                {imageInfoStatus && imageInfo.info.age_limit === 1 ? <AdIMobile id="im-082e74f637214cab980b6ce0c0716241" pid={9144} mid={564523} asid={1835643} /> : ""}
                                {imageInfoStatus && (imageInfo.info.age_limit === 4 || imageInfo.info.age_limit === 5) ? <div className='d-flex justify-content-start'><DLsite list={adList} imageList={imageList} /></div> : ""}
                                {/*imageInfoStatus && imageInfo.info.style_of_painting === 2 && (imageInfo.info.age_limit === 2 || imageInfo.info.age_limit === 3) ? <div style={{width:"100%" ,marginTop: "18px",paddingTop: "75%", position:"relative"}}><iframe width="100%" height="100%" maxWidth="1280px" style={{position: "absolute",top: 0, "left": 0}} src="https://www.dmm.co.jp/litevideo/-/part/=/affi_id=younashi-009/cid=mimk00136/size=1280_720/" scrolling="no" frameBorder="0" allowFullScreen></iframe></div> : ""*/}
                                {imageInfoStatus && imageInfo.info.age_limit !== 4 && imageInfo.info.age_limit !== 5 ? <div className='text-center mt-1'>
                                    <Link to={"https://amzn.to/3LT4jKY"} target='_blank' style={{border:"1px solid black"}} className='d-inline-block mb-3'>
                                        <img src='https://m.media-amazon.com/images/I/615uZwGKnJL._AC_SL1500_.jpg' height={100} />[PR] Anker Prime Power Bank (モバイルバッテリー 27650mAh 合計最大250W出力)
                                    </Link>
                                </div>: ""}
                            </div>
                            </>) : (
                                <>
                            {/* モバイル向け */}
                            <div className='mt-3'>
                                {imageInfoStatus && imageInfo.info.age_limit === 1 ? <div className='d-flex justify-content-start'><DLsite list={adList} imageList={imageList} /></div> : ""}
                                {imageInfoStatus && imageInfo.info.age_limit === 1 ? <AdIMobile id="im-4f9f751412054c98abdb16181ce821b6" pid={9144} mid={564523} asid={1835642} /> : ""}
                                {imageInfoStatus && (imageInfo.info.age_limit === 4 || imageInfo.info.age_limit === 5) ? <div className='d-flex justify-content-start'><DLsite list={adList} imageList={imageList} /></div> : ""}
                                {/*imageInfoStatus && imageInfo.info.style_of_painting === 2 && (imageInfo.info.age_limit === 2 || imageInfo.info.age_limit === 3) ? <div style={{width:"100%" ,marginTop: "18px",paddingTop: "75%", position:"relative"}}><iframe width="100%" height="100%" maxWidth="1280px" style={{position: "absolute",top: 0, "left": 0}} src="https://www.dmm.co.jp/litevideo/-/part/=/affi_id=younashi-009/cid=mimk00136/size=1280_720/" scrolling="no" frameBorder="0" allowFullScreen></iframe></div> : ""*/}
                                {imageInfoStatus && imageInfo.info.age_limit !== 4 && imageInfo.info.age_limit !== 5 ? <div className='text-center mt-1'>
                                    <Link to={"https://amzn.to/3LT4jKY"} target='_blank' style={{border:"1px solid black"}} className='d-inline-block mb-3'>
                                        <img src='https://m.media-amazon.com/images/I/615uZwGKnJL._AC_SL1500_.jpg' height={100} />Anker Prime Power Bank (モバイルバッテリー 27650mAh 合計最大250W出力)
                                    </Link>
                                </div>: ""}
                            </div></>
                            )
                    )}
                    {loginInfo.plan === undefined || loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : <>
                        {imageInfoStatus ? (<>
                            {loginInfo.result && loginInfo.r18_display_flag === 1 && (imageInfo.info.age_limit === 4 || imageInfo.info.age_limit === 5) ? (
                                <Link to="/generate_unlimit" className='d-flex justify-content-center'><SBAlert severity='info' className="m-3 p-2 text-center" style={{display:"inline-block"}}>R18画像生成<br /><Image src="/img/unlimit/ad.webp" width={240} /></SBAlert></Link>
                            ) : ""}
                        </>) : ""}
                    </>}
                </Container>
                : ""}
                </Col>
                </Row>
            </div>
            <Container className='mt-1 mb-1' style={{fontSize:"24px",fontWeight:"bold",display:"block"}}>
                <Icon.ChatLeftText style={{paddingBottom:"1px"}} /> 最新コメント
            </Container>
            <div className='d-flex flex-row justify-content-start w-100 thumbnail-bar mousewrap' style={{width:"1200px",overflow:"auto"}}>
            {latestCommentList.map((d,i) => {
                return <div style={{width:"374px"}} className='d-flex justify-content-between'>
                    <Thumb type={"image"} isLink={true} data={{group_id:d.group_id,title:""}} i={i} from="latest_comment" dialog={dialog} key={i} observer={observer} list={latestCommentList} listName={"最新コメント"} />
                    <div className='balloon2-left' style={{width:"154px",height:"148px"}}>{d.stamp_id !== "" ? <>
                        <Image loading="lazy" width="128px" height="128px" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(d.stamp_id)+"_m"+ApiFetch.API_THUMB_EXT} onContextMenu={(e) => e.preventDefault()} />
                    </>: d.text.substr(0,50)}</div>
                </div>
            })}
            </div>
            {loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : (
            <Container className='text-center d-block d-md-none'>
                {/*<iframe src="https://rcm-fe.amazon-adsystem.com/e/cm?o=9&p=12&l=ur1&category=kindleunlimited&banner=0AB3H18G96CHRYZ8TV02&f=ifr&linkID=b57bbac32b9dddb3e519cdb323062486&t=ourt-ai-22&tracking_id=ourt-ai-22" width="300" height="250" scrolling="no" border="0" marginWidth="0" style={{border:"none"}} frameBorder="0" sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"></iframe>*/}
                <script src="https://adm.shinobi.jp/s/3f3cca24c3b93bd2b4faaf3752c37d83"></script>
            </Container>
            )}
            <Container style={{fontSize:"24px",fontWeight:"bold"}} className='mt-3 mb-3 p-0'>{t("")}</Container>
            <Container className='text-center'>
                <Button variant='outline-primary' className='m-3 p-3' onClick={() => {
                    setShowKanren(!showKanren)
                    setSearchImage(Math.random())
                }}>もっと見る</Button>
            </Container>
            {showKanren ? (<>
                <Container className='p-0 lazy-popup' data-type='search'>
                    <Icon.GearFill
                        onClick={() => setShowDisplaySetting(true)}
                        style={{fontSize:"32px",marginLeft:"10px",marginRight:"10px",cursor:"pointer"}} />
                    <h3>#{tag}</h3>
                </Container>
                {/**
                 <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column"
                    >
                    {imageList.map((data,i) => {
                        if(omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id  || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                            return <span data-no={i} className="lazy-hidden" key={i}></span>
                        }
                        return <Tile data={data} i={i} dialog={dialog} key={i} from="popup" list={imageList.filter(d => d.mute === 0)} listName={"#"+tag}
                        onClick={() => {
                            setViewList(imageList.filter(d => d.mute === 0))
                            setViewListName("#"+tag)
                            setViewListIndex(i)

                            setGroupId(data.group_id)
                            // スクロールを最上位に戻す
                            document.getElementById("popup-view").scrollTo({top:0,left:0,behavior:"instant"})
                            setDetailNo(0)
                        }}
                        init={() => setImageInfoStatus(false)}
                        />
                    })}
                </Masonry>
                 */}
                {tileMode ? (
                <Gallery images={imageList.map(d => {
                    d.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath("image") + '/post/t/'+(d.id)+"_m"+ApiFetch.API_THUMB_EXT
                    d.aspect = d.width/d.height
                    return d
                }).map((d,i) => {
                    if(omitContinuous && i > 0 && imageList[i-1].user_id === d.user_id  || (d.user_id !== loginInfo.userId && d.search_ban === 1)){
                        d.isMute = true
                    } else {
                        d.isMute = false
                    }
                    return d
                })} dialog={dialog} thumbnailOnClick={(d,i) => {
                    setViewList(imageList.filter(d => d.mute === 0))
                    setViewListName("#"+tag)
                    setViewListIndex(i)

                    setGroupId(d.group_id)
                    // スクロールを最上位に戻す
                    document.getElementById("popup-view").scrollTo({top:0,left:0,behavior:"instant"})
                    setDetailNo(0)
                }} init={() => setImageInfoStatus(false)} from={"popup"} />
                ) : (
                    <div className='d-flex flex-row justify-content-start flex-wrap w-100'
                    >
                        {imageList.map((data,i) => {
                            if(data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                                return <span data-no={i} className="lazy-popup" key={i}></span>
                            }
                        return <Thumb data={data} i={i} dialog={dialog} key={i} from="popup" list={imageList.filter(d => d.mute === 0)} listName={"#"+tag}
                        onClick={() => {
                            setViewList(imageList.filter(d => d.mute === 0))
                            setViewListName("#"+tag)
                            setViewListIndex(i)

                            setGroupId(data.group_id)
                            // スクロールを最上位に戻す
                            document.getElementById("popup-view").scrollTo({top:0,left:0,behavior:"instant"})
                            setDetailNo(0)
                        }}
                        init={() => setImageInfoStatus(false)}
                        />
                        })}
                    </div>
                )}
                <Container className='mt-4 mb-3' style={{fontSize:"24px",fontWeight:"bold",display:"block",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>
                    <Icon.SortUpAlt style={{paddingBottom:"1px",color:"orange"}} /> {t("home.popularContributors")}
                </Container>
                <Container className='w-100 mb-3' style={{display:"block"}}>
                    <Row>
                    {last3MonthAvg.map((data,i) => {
                    return <Col xs={5} sm={5} md={3} lg={2} xl={2} xxl={2} style={{margin:"0 auto",textAlign:"center",fontWeight:"bold"}} key={i}>
                                <UserAvatarWithLikes 
                                    userId={data.user_id} 
                                    size="100%" 
                                    linkTo={"/user/"+(data.user_id)}
                                />
                                <LinkContainer to={"/user/"+(data.user_id)} style={{color:"#555555",textDecoration:"none",cursor:"pointer"}}><span>{data.user_name}</span></LinkContainer><br />
                                <FollowButton userId={data.user_id} />
                        </Col>
                    })}
                    </Row>
                </Container>
            </>) : ""}
            <Link to={"/about"}><Alert severity='info' className='text-center'>ご支援について</Alert></Link>
        </div>
    </div>
</div>
    )
}

export default ImageViewPopup;
